export default "__VITE_ASSET__Clpbp8ZB__"